import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { isEmail } from 'validator';
import { toast } from 'react-toastify';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';

import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../store/modules/auth/actions';

import { Input80px } from '../styles/inputGroup';

import Card from '../components/card';
import Loading from './loading';

const LOGIN_REFRESH_KEY = 'eloadmin:refresh-after-login';

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isLoading, isLoggedIn } = useSelector((state) => state.auth);
  const cancelar = true;

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');

  useEffect(() => {
    if (isLoggedIn) {
      if (sessionStorage.getItem(LOGIN_REFRESH_KEY)) {
        sessionStorage.removeItem(LOGIN_REFRESH_KEY);

        const url = new URL(window.location.href);
        url.searchParams.set('_refresh', Date.now().toString());
        url.hash = '/home';
        window.location.replace(url.toString());
        return;
      }

      navigate('/home');
    }
  }, [isLoggedIn, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();

    let formErros = false;

    if (!isEmail(email)) {
      formErros = true;
      toast.error('E-mail inválido');
    }

    if (senha.length <= 0) {
      formErros = true;
      toast.error('Senha deve ser informada');
    }

    if (formErros) return;

    sessionStorage.setItem(LOGIN_REFRESH_KEY, 'true');
    dispatch(actions.loginRequest({ email, senha }));
  };

  return (
    <div className="login-page">
      <Loading isLoading={isLoading} cancelar={cancelar} />

      <div className="login-card-wrap">
          <Card title="Acesse sua conta">
            <p className="login-subtitle">Use suas credenciais para continuar.</p>
            <div className="row">
              <div className="col-lg-12">
                <div className="bs-component">
                  <div className="row form-elo">
                    <div className="col-12">
                      <div className="p-inputgroup">
                        <Input80px className="p-inputgroup-addon">
                          <i className="pi pi-envelope" />
                        </Input80px>
                        <InputText
                          id="inputEmail"
                          value={email}
                          onChange={e => setEmail(e.target.value)}
                          placeholder="seu@email.com"
                          autoComplete="email"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row form-elo">
                    <div className="col-12">
                      <div className="p-inputgroup">
                        <Input80px className="p-inputgroup-addon">
                          <i className="pi pi-lock" />
                        </Input80px>
                        <Password
                          toggleMask
                          feedback={false}
                          id="inputSenha"
                          value={senha}
                          onChange={e => setSenha(e.target.value)}
                          placeholder="Digite sua senha"
                          autoComplete="current-password"
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={handleSubmit}
                    type="button"
                    className="btn btn-primary login-submit"
                  >
                    Entrar <i className="pi pi-arrow-right"></i>
                  </button>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                &nbsp;
              </div>
              { /* <div className="col-lg-12">
                <div className="bg-white p-8 rounded-2xl shadow-lg max-w-md w-full text-center border-t-4 border-yellow-500">
                  <h1 className="text-3xl font-bold text-gray-800 mb-4">Aviso de Manutenção</h1>
                  <p className="text-gray-700 text-lg">
                    Prezados usuários, informamos que uma manutenção essencial em nossos serviços está programada para iniciar às
                    <strong className="text-yellow-600"> 14h do dia 30 de Agosto. </strong>
                  </p>
                  <p>
                    Os serviços serão reestabelecidos após a conclusão dos trabalhos no
                    <strong className="text-yellow-600"> final do dia 31 de Agosto. </strong>
                    Contamos com sua paciência e colaboração.
                  </p>
                  <p className="text-gray-600 text-sm mt-4"> Agradecemos a sua compreensão. </p>
                  <hr />
                </div>
              </div> */}
            </div>
          </Card>
      </div>
    </div>
  );
}
